import type { ThemeOptions } from '@mui/material'
import type { TypographyOptions } from '@mui/material/styles/createTypography'
import { SpaceGrotesk, Technomite } from '@/assets/fonts'

const variants = {
  h1: {
    ...Technomite.style,
  },
  h2: {
    ...Technomite.style,
  },
  h3: {
    ...Technomite.style,
  },
  bodySmall: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '18px',
    color: 'rgba(255, 255, 255, 0.7)',
    ...SpaceGrotesk.style,
  },
  body1: { fontWeight: 700, fontSize: 16, lineHeight: '20px', ...SpaceGrotesk.style },
  body2: { fontWeight: 500, fontSize: 16, lineHeight: '20px', ...SpaceGrotesk.style },
  subtitle1: { fontWeight: 500, fontSize: 14, lineHeight: '18px', ...SpaceGrotesk.style },
} as TypographyOptions

export type ITypographyVariants = keyof typeof variants

export const TypographyVariants = {
  // fontFamily: `${SpaceGrotesk.style.fontFamily}, ${Technomite.style.fontFamily}`,
  ...variants,
} as TypographyOptions

const theme = {
  components: {
    defaultProps: {
      variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
      },
    },
  },
} as ThemeOptions

export const TypographyComponent = theme.components
